"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _excluded = ["defaultLanguage", "intl", "value", "uriTransformer", "propsPrefix", "defaultValue", "visible", "cssImage", "height", "children", "style", "isFixed"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _reactIntl = require("react-intl");
var _Video = _interopRequireDefault(require("./Video"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Background = /*#__PURE__*/function (_react$default$Compon) {
  function Background() {
    _classCallCheck(this, Background);
    return _callSuper(this, Background, arguments);
  }
  _inherits(Background, _react$default$Compon);
  return _createClass(Background, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultLanguage = _this$props.defaultLanguage,
        intl = _this$props.intl,
        value = _this$props.value,
        _this$props$uriTransf = _this$props.uriTransformer,
        uriTransformer = _this$props$uriTransf === void 0 ? function (uri) {
          return uri;
        } : _this$props$uriTransf,
        propsPrefix = _this$props.propsPrefix,
        defaultValue = _this$props.defaultValue,
        _this$props$visible = _this$props.visible,
        visible = _this$props$visible === void 0 ? true : _this$props$visible,
        _this$props$cssImage = _this$props.cssImage,
        cssImage = _this$props$cssImage === void 0 ? false : _this$props$cssImage,
        _this$props$height = _this$props.height,
        height = _this$props$height === void 0 ? "100%" : _this$props$height,
        children = _this$props.children,
        style = _this$props.style,
        _this$props$isFixed = _this$props.isFixed,
        isFixed = _this$props$isFixed === void 0 ? false : _this$props$isFixed,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var backgroundDef = {
        background_type: value["".concat(propsPrefix, "background_type")] === 'default' ? defaultValue["".concat(propsPrefix, "background_type")] : value["".concat(propsPrefix, "background_type")],
        background_video_uri: value["".concat(propsPrefix, "background_type")] === 'default' ? defaultValue["".concat(propsPrefix, "background_video_uri")] : (0, _utils.i18nData)(value, "".concat(propsPrefix, "background_video_uri"), intl, defaultLanguage),
        background_color: value["".concat(propsPrefix, "background_type")] === 'default' ? defaultValue["".concat(propsPrefix, "background_color")] : value["".concat(propsPrefix, "background_color")],
        background_image_uri: value["".concat(propsPrefix, "background_type")] === 'default' ? defaultValue["".concat(propsPrefix, "background_image_uri")] : (0, _utils.i18nData)(value, "".concat(propsPrefix, "background_image_uri"), intl, defaultLanguage)
      };
      var fullStyle = _objectSpread(_objectSpread(_objectSpread({
        width: '100%',
        height: height,
        position: 'absolute'
      }, style), Background.backgroundCss(backgroundDef, cssImage, uriTransformer)), !visible ? {
        display: 'none'
      } : {});
      var backgroundClasses = "tsku-background ".concat(isFixed ? 'tsku-background--is-fixed' : '');
      if (!cssImage && backgroundDef.background_type === 'image' && !!backgroundDef.background_image_uri) {
        return /*#__PURE__*/_react.default.createElement("div", _extends({
          style: fullStyle
        }, otherProps), /*#__PURE__*/_react.default.createElement("img", {
          className: backgroundClasses,
          style: !isFixed ? {
            height: height
          } : null,
          src: uriTransformer(backgroundDef.background_image_uri),
          alt: "background",
          "aria-hidden": "true"
        }), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: height
          }
        }, children));
      }
      if (backgroundDef.background_type === 'video') {
        return /*#__PURE__*/_react.default.createElement("div", _extends({
          style: fullStyle
        }, otherProps), /*#__PURE__*/_react.default.createElement(_Video.default, _extends({
          className: backgroundClasses,
          style: !isFixed ? {
            height: height
          } : null,
          muted: false,
          src: uriTransformer(backgroundDef.background_video_uri)
        }, backgroundDef.background_image_uri ? {
          poster: uriTransformer(backgroundDef.background_image_uri)
        } : {})), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: height
          }
        }, children));
      }
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        style: fullStyle
      }, otherProps), children);
    }
  }]);
}(_react.default.Component);
_defineProperty(Background, "whyDidYouRender", true);
_defineProperty(Background, "defaultProps", {
  uriTransformer: function uriTransformer(u) {
    return u;
  },
  propsPrefix: ''
});
_defineProperty(Background, "backgroundCss", function (backgroundDef, cssImage, uriTransformer) {
  switch (backgroundDef.background_type) {
    case 'image':
      if (cssImage && !!backgroundDef.background_image_uri) return {
        background: "url(".concat(uriTransformer(backgroundDef.background_image_uri), ") no-repeat center center/cover")
      };
      return {};
    case 'color':
      return {
        background: backgroundDef.background_color
      };
    default:
      return {};
  }
});
var _default = exports.default = (0, _reactIntl.injectIntl)(Background);